
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 24a12 12 0 1112-12 12.013 12.013 0 01-12 12zm0-23a11 11 0 1011 11A11.013 11.013 0 0012 1z"}}),_c('path',{attrs:{"d":"M12 15.5a.5.5 0 01-.5-.5v-2.25a.5.5 0 01.5-.5 2.943 2.943 0 003-2.875 3 3 0 00-6 0 .5.5 0 01-1 0 4 4 0 018 0 3.926 3.926 0 01-3.5 3.845V15a.5.5 0 01-.5.5zm0 3a.75.75 0 11.75-.75.75.75 0 01-.75.75zm0-1a.25.25 0 00-.25.25c0 .275.5.275.5 0a.25.25 0 00-.25-.25z"}})])
          )
        }
      }
    